import { Component, type ReactElement } from "react";

import { TooltipController } from "../overlays/components/OverlayControllers.js";

export interface IRadioProps {
  id: string;
  checked?: boolean;
  defaultChecked?: boolean;
  label?: string | ReactElement;
  disabled?: boolean;
  style?: any;
  value?: string;
  tooltipText?: string; // defaults to label if undefined
  browserTooltip?: boolean; // use browser style tooltip
  name?: string;

  onChange?: (event: any) => void;
  onBlur?: () => void;
}

export interface IRadioState {
  defaultChecked: boolean;
}

const hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

function emptyFn() {
  /* empty */
}

export class Radio extends Component<IRadioProps, IRadioState> {
  constructor(props: IRadioProps) {
    super(props);
    this.state = {
      defaultChecked: this.props.defaultChecked,
    };

    this.isChecked = this.isChecked.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  render() {
    const props = { ...this.props, onChange: this.handleChange, label: "" };

    const { tooltipText, ...otherProps } = props;

    return (
      <TooltipController content={tooltipText} overlayOptions={{ placement: "left", offset: 10 }}>
        {(tooltipTriggerProps) => (
          <span style={props.style} {...tooltipTriggerProps}>
            <input
              type="radio"
              {...otherProps} // delivers the optional value
              checked={this.isChecked()}
              disabled={this.props.disabled || false}
              onBlur={this.props.onBlur}
            />
            <label htmlFor={this.props.id}>
              <span>{this.props.label || " "}</span>
            </label>
          </span>
        )}
      </TooltipController>
    );
  }

  private isChecked(): boolean {
    return this.getValue() || false;
  }

  private getValue(): boolean {
    const props = this.props;
    return hasOwn(props, "checked") ? props.checked : this.state.defaultChecked;
  }

  private handleChange(event) {
    const value = event.target.checked;
    const props = this.props;

    // if (props.supportIndeterminate){
    //   var oldValue = this.getValue()
    //
    //   if (typeof props.nextValue == 'function'){
    //     value = props.nextValue(oldValue, this.props)
    //   }
    // }

    (props.onChange || emptyFn)(event);

    if (!hasOwn(props, "checked")) {
      this.setState({
        defaultChecked: value,
      });
    }

    event.stopPropagation();
  }
}

export default Radio;
